import React from 'react'
import { Box, Center, Flex, Img, Stack, Text, VStack } from '@chakra-ui/react';
import img from "../../Assets/Images/hassan.jpeg";
import img1 from "../../Assets/Images/Mohsin.jpeg";
import img2 from "../../Assets/Images/touseef.jpeg";
import img3 from "../../Assets/Images/man1.png";

export default function OtherMembers() {
  const textStyle = {
    color: "#1F508B",
    fontSize: "18px",
    fontWeight: "300",
    lineHeight: "1.5rem"
  };
  return (
    <Center>
      <Stack maxW={"1120px"} width={"100%"} alignItems={"center"} mt={"60px"} >
        <Box>
          <Flex mb={"150px"} justifyContent={"center"} gap={"110px"} flexWrap={"wrap"}>
            <VStack>
              <Img
                boxShadow={"lg"}
                borderRadius="full"
                boxSize="180px"
                alt="ceo"
                border={"12px solid white"}
                src={img}
                _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }}
              />
              <Text {...textStyle} mt={"20px"}>
                Hassan Ibrahim
              </Text>
              <Text {...textStyle} mt={"1px"}>
                Family Offices Executive
              </Text>
            </VStack>
            <VStack>
              <Img
                boxShadow={"lg"}
                borderRadius="full"
                boxSize="180px"
                alt="ceo"
                border={"12px solid white"}
                src={img1}
                _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }}
              />
              <Text {...textStyle} mt={"20px"}>
                Mohsin Niazi
              </Text>
              <Text {...textStyle} mt={"1px"}>
                VP Operations
              </Text>
            </VStack>
            <VStack>
              <Img
                boxShadow={"lg"}
                borderRadius="full"
                boxSize="180px"
                alt="ceo"
                border={"12px solid white"}
                src={img2}
                _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }}
              />
              <Text {...textStyle} mt={"20px"}>
                Touseef Ali
              </Text>
              <Text {...textStyle} mt={"1px"}>
                Client Services Manager
              </Text>
            </VStack>
            <VStack>
              <Img
                boxShadow={"lg"}
                borderRadius="full"
                boxSize="180px"
                alt="ceo"
                border={"12px solid white"}
                src={img3}
                _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }}
              />
              <Text {...textStyle} mt={"20px"}>
                Abdr Rehman Hairs
              </Text>
              <Text {...textStyle} mt={"1px"}>
                CRE Account Executive
              </Text>
            </VStack>
          </Flex>
        </Box>
      </Stack>
    </Center>
  )
}
